import type { Messages } from '../en'

export const beats: Messages['beats'] = {
  gettingStarted: 'Começando',
  reviewingBrief: 'Lendo o briefing',
  attachmentsChip: (n) => (n === 1 ? '1 anexo' : `${n} anexos`),
  collectingAttachments: (n) => (n === 1 ? 'Coletando 1 anexo' : `Coletando ${n} anexos`),
  referenceVolumesChip: (n) => (n === 1 ? '1 volume de referência' : `${n} volumes de referência`),
  consultingLibrary: (n) =>
    n === 1
      ? 'Consultando a biblioteca — 1 volume de referência tirado da estante'
      : `Consultando a biblioteca — ${n} volumes de referência tirados da estante`,
  thinking: 'Pensando com cuidado',
  writing: 'Escrevendo',
  coffeeBreak: 'Trecho longo — um café rápido e já volta',
  retryChip: (attempt) => `tentativa nº ${attempt}`,
  retryCaption: (attempt) => `Encontrou um obstáculo — tentando de novo (tentativa ${attempt})`,
  adjustingChip: 'ajustando',
  adjustingCaption: 'Tentou usar uma ferramenta que não está disponível — ajustando e seguindo em frente',
  checkingNotesChip: 'conferindo anotações',
  checkingNotesCaption: 'Consultando os arquivos do caso',
  noReplyInTime: 'Sem resposta a tempo — seguindo com premissas',
  runCancelled: 'Encerrando — execução cancelada',
  replyArrived: 'Sua resposta chegou',
  waitingForReply: 'Aguardando sua resposta',
  filesChip: (n) => (n === 1 ? '1 arquivo' : `${n} arquivos`),
  packingFiles: (n) => (n === 1 ? 'Empacotando 1 arquivo' : `Empacotando ${n} arquivos`),
  delivered: 'Entregue',
  deliveredWithNotes: 'Entregue — com observações',
  runFailed: 'A execução falhou',
  runFailedWithReason: (reason) => `A execução falhou — ${reason}`,
  hasAQuestion: 'Tem uma pergunta para você',
  briefingSpecialist: 'Passando instruções a um especialista',
  callingChip: (server) => `chamando ${server}`,
  onTheLine: (server) => `Na linha com ${server}`,
  workbenchCaption: (task) => `Na bancada — ${task}`,
  toolLabels: {
    code_execution: { chip: 'montando a entrega', caption: 'Na bancada — montando a sua entrega' },
    bash_code_execution: { chip: 'executando comandos', caption: 'Na bancada — executando comandos' },
    text_editor_code_execution: { chip: 'ajustando arquivos', caption: 'Na bancada — ajustando os arquivos' },
    str_replace_editor: { chip: 'ajustando arquivos', caption: 'Na bancada — ajustando os arquivos' },
    web_search: { chip: 'pesquisando na web', caption: 'Pesquisando respostas na web' },
    web_fetch: { chip: 'lendo uma página', caption: 'Lendo uma página externa' }
  },
  settingTheStage: 'Preparando o palco',
  specialistsOnIt: (caption, n) => `${caption} · ${n} especialista${n === 1 ? '' : 's'} na tarefa`,
  breakChip: 'café',
  welcomingSpecialists: 'Segurando a porta para os especialistas',
  standupBriefing: 'Reunião rápida — passando o briefing'
}
